// AuthHandler.jsx
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { loginThunk } from "../redux/slices/authSlice";


const AuthHandler = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const handleAuth = async () => {
      const hash = location.hash;
      const hashSegments = hash.split("/");
      const isSpecificFilterRoute = hashSegments.length === 3;

      // Case 1: Handle direct username/authToken route
      if (location.pathname.includes("/authToken/")) {
        const segments = location.pathname.split("/");
        const username = segments[1];
        const authToken = segments[3];

        try {
          await dispatch(
            loginThunk({
              username: decodeURIComponent(username),
              token: authToken,
            })
          ).unwrap();
          return;
        } catch (error) {
          console.error("Login failed:", error);
        }
      }

      // Case 2: Handle node URL with auth token
      if (hash.includes("filter_includeManual=") && isSpecificFilterRoute) {
        const [nodeUrlPart, token, username] = hash.split("/").slice(-3);
        const nodeUrl = hash.split("/").slice(0, -2).join("/");

        if (token && username) {
          try {
            await dispatch(
              loginThunk({
                username: decodeURIComponent(username),
                token,
              })
            ).unwrap();
            navigate(nodeUrl);
            return;
          } catch (error) {
            console.error("Login failed:", error);
          }
        }
      }

      // Case 3: Handle specific filter route
      // if (select && isSpecificFilterRoute) {
      //   const username = hashSegments[2];
      //   const authToken = hashSegments[1];

      //   try {
      //     await dispatch(
      //       loginThunk({
      //         username: decodeURIComponent(username),
      //         token: authToken,
      //       })
      //     ).unwrap();
      //   } catch (error) {
      //     console.error("Login failed:", error);
      //   }
      // }
    };

    handleAuth();
  }, [location, navigate, dispatch]);

  return null;
};

export default AuthHandler;
